import React from "react";
import { createRoot } from "react-dom/client";
import RobotTxtGenerator from "../components/free-tools/RobotTxtGenerator";
import ToastProvider from "../components/shared/ToastProvider";

document.addEventListener("DOMContentLoaded", () => {
  const rootElement = document.getElementById("robot-txt-generator-main");
  if (rootElement) {
    const root = createRoot(rootElement);
    root.render(
      <>
        <ToastProvider />
        <RobotTxtGenerator />
      </>
    );
  }
});
